import {
  Box,
  Button,
  Dialog,
  DialogContent,
  DialogTitle,
  Divider,
  TextField,
  Typography,
  makeStyles,
} from "@material-ui/core";

import DialogCloseButton from "./DialogCloseButton";
import { useTranslate } from "react-admin";

const useStyles = makeStyles((theme) => ({
  paper: {
    margin: "0px auto",
    width: 668,
    maxWidth: 1500,
    // height: 1200,
    borderRadius: "10px",
  },
  dialogContainer: {
    margin: "0 auto",
  },
  title: {
    color: theme.orange,
    fontSize: 30,
    fontWeight: "bold",
    margin: "10px auto 0",
    display: "table",
  },
  productText: { fontSize: 12, fontWeight: 600 },
  productCode: { fontSize: 8 },
  productGrid: {
    width: "402px",
    display: "grid",
    margin: "0 auto",
    gridTemplateColumns: "200px auto 100px",
    gridAutoRows: "auto",
    gap: 5,
  },
  summaryGrid: {
    width: "402px",
    display: "grid",
    margin: "0 auto",
    gridTemplateColumns: "50% auto",
    gridAutoRows: "auto",
    gap: 7,
  },
  gridLeft: {
    justifySelf: "start",
  },
  gridCenter: {
    justifySelf: "center",
  },
  gridRight: {
    justifySelf: "end",
  },
  container: {
    display: "flex",
    justifyContent: "space-between",
    margin: "auto 50px",
  },
  note: {
    width: 402,
    margin: "5px auto",
  },
  textBottom: {
    fontStyle: "normal",
    fontSize: 12,
    fontWeight: 600,
    lineHeight: 1,
  },
  totalText: {
    fontStyle: "normal",
    fontWeight: 800,
    fontSize: 20,
    color: theme.blue,
  },
  button: {
    fontSize: 30,
    fontWeight: "bold",
    color: "white",
    borderRadius: "0 0",
  },
}));

const FullReceiptDialog = ({
  products,
  paymentTransaction,
  //  discount,
  onClose,
  onClick,
  open,
  setNote,
  note,
  disabled,
  fullPaymentBeforeChange,
  setCustomTime,
}) => {
  const classes = useStyles();
  const translate = useTranslate();

  const tierPrivilege = paymentTransaction.items.filter(
    (i) => i.item_type === "privilege"
  );

  const discounts = paymentTransaction.items.filter(
    (i) =>
      i.item_type === "offer" &&
      i.coupons[0].type === "discount" &&
      !i.coupons[0].discount_percent
  );

  const discountsPercent = paymentTransaction.items.filter(
    (i) =>
      i.item_type === "offer" &&
      i.coupons[0].type === "discount" &&
      i.coupons[0].discount_percent
  );

  const specialOfferMultiply = paymentTransaction.items.filter(
    (i) => i.item_type === "offer" && i.coupons[0].type === "multiplier"
  );

  const specialOfferPlus = paymentTransaction.items.filter(
    (i) => i.item_type === "offer" && i.coupons[0].type === "reward"
  );

  const redeems = paymentTransaction.items.filter(
    (i) => i.item_type === "discount"
  );

  const deliveryCost = paymentTransaction.delivery_cost
    ? paymentTransaction.delivery_cost
    : 0;

  return (
    <Dialog
      onClose={onClose}
      open={open}
      classes={{ root: classes.dialogContainer, paper: classes.paper }}
    >
      <DialogTitle>
        <Typography className={classes.title}>
          {translate("ra.text.paymentConfirmation.paymentConfirmation")}
        </Typography>
      </DialogTitle>
      <DialogCloseButton onClose={onClose} />
      <DialogContent>
        <Box className={classes.productGrid}>
          <Typography className={classes.gridLeft}>
            {translate("ra.text.addProduct.productName")}
          </Typography>
          <Typography className={classes.gridCenter}>
            {translate("ra.text.qty")}
          </Typography>
          <Typography className={classes.gridRight}></Typography>

          {products.map((product) => {
            return (
              <>
                <Box className={classes.gridLeft} style={{ width: 110 }}>
                  <Typography noWrap className={classes.productText}>
                    {product.name}
                  </Typography>
                  <Typography noWrap className={classes.productCode}>
                    {process.env.REACT_APP_CUSTOM_HIDE_PRODUCT_CODE === "yes"
                      ? ""
                      : product.code}
                  </Typography>
                </Box>
                <Typography
                  className={[classes.gridCenter, classes.productText]}
                >
                  {product.qty}
                </Typography>
                <Typography
                  className={[classes.gridRight, classes.productText]}
                >
                  THB {commaNumber(product.price)}
                </Typography>
              </>
            );
          })}
          {deliveryCost > 0 && (
            <>
              <Box className={classes.gridLeft} style={{ width: 110 }}>
                <Typography noWrap className={classes.productText}>
                  {translate("ra.text.delivery_cost")}
                </Typography>
                <Typography noWrap className={classes.productCode}></Typography>
              </Box>
              <Typography
                className={[classes.gridCenter, classes.productText]}
              ></Typography>
              <Typography className={[classes.gridRight, classes.productText]}>
                THB {commaNumber(deliveryCost)}
              </Typography>
            </>
          )}
        </Box>
        <Divider
          style={{
            margin: "10px auto",
            width: 402,
            //border: "1px solid rgba(130, 130, 130, 0.18)",
          }}
        />

        <Box className={classes.summaryGrid}>
          <Typography className={classes.textBottom}>
            {translate("ra.text.receipt.subtotal")}
          </Typography>
          <Typography className={[classes.textBottom, classes.gridRight]}>
            THB{" "}
            {commaNumber(
              paymentTransaction.summary.total_payment + deliveryCost
            )}
          </Typography>

          {/* <Typography className={classes.textBottom}>Tier discount</Typography>
          <Typography className={[classes.textBottom, classes.gridRight]}>
            Put here
          </Typography> */}
          {tierPrivilege.map((tier) => {
            return tier.coupons.map((coupon) => {
              if (coupon.type) {
                return (
                  <>
                    <Typography
                      className={classes.textBottom}
                    >{`${paymentTransaction.tier_name} ${coupon.desc}`}</Typography>
                    <Typography
                      className={[classes.textBottom, classes.gridRight]}
                    >
                      {`${coupon.descValue}`}
                    </Typography>
                  </>
                );
              } else return null;
            });
          })}

          {discounts.map((discount) => {
            return (
              <>
                <Typography
                  className={classes.textBottom}
                >{`${discount.coupons[0].shortDesc}`}</Typography>
                <Typography className={[classes.textBottom, classes.gridRight]}>
                  {`THB ${commaNumber(discount.coupons[0].discount_amount)}`}
                </Typography>
              </>
            );
          })}

          {discountsPercent.map((discount) => {
            return (
              <>
                <Typography
                  className={classes.textBottom}
                >{`${discount.coupons[0].shortDesc}`}</Typography>
                <Typography className={[classes.textBottom, classes.gridRight]}>
                  {`THB ${commaNumber(discount.coupons[0].discount_amount)}`}
                </Typography>
              </>
            );
          })}

          {/* <Typography className={classes.textBottom}>
            {translate("ra.text.total")} {translate("ra.text.discount")}{" "}
            {discount?.name}
          </Typography>
          <Typography className={[classes.textBottom, classes.gridRight]}>
            THB {commaNumber(paymentTransaction.summary.total_discount)}
          </Typography> */}
          {specialOfferMultiply.map((offer) => {
            return (
              <>
                <Typography className={classes.textBottom}>{`${translate(
                  "ra.text.specialOffers"
                )} ${offer.coupons[0].shortDesc}`}</Typography>
                <Typography
                  className={[classes.textBottom, classes.gridRight]}
                ></Typography>
              </>
            );
          })}

          {specialOfferPlus.map((offer) => {
            return (
              <>
                <Typography className={classes.textBottom}>{`${translate(
                  "ra.text.specialOffers"
                )} ${offer.coupons[0].shortDesc}`}</Typography>
                <Typography
                  className={[classes.textBottom, classes.gridRight]}
                ></Typography>
              </>
            );
          })}

          {redeems.map((redeem) => {
            return (
              <>
                <Typography className={classes.textBottom}>
                  {`${translate("ra.text.pointasCash")} ${Math.abs(
                    redeem.redeem?.amount
                  )} ${translate("ra.text.points")}`}
                </Typography>
                <Typography className={[classes.textBottom, classes.gridRight]}>
                  {`THB ${commaNumber(redeem.discount_amount)}`}
                </Typography>
              </>
            );
          })}

          <Typography className={classes.textBottom}>
            {translate("ra.text.addProduct.total")}
          </Typography>

          <Typography className={[classes.textBottom, classes.gridRight]}>
            THB{" "}
            {commaNumber(
              paymentTransaction.summary.total_revenue + deliveryCost
            )}
          </Typography>

          <Typography className={classes.textBottom}>
            {translate("ra.text.addProduct.pointtobeEarned")}
          </Typography>
          <Typography className={[classes.textBottom, classes.gridRight]}>
            {commaNumber(paymentTransaction.summary.earn_amount)}
          </Typography>

          <PurchaseBySection paymentTransaction={paymentTransaction} />

          <Typography noWrap className={classes.totalText}>
            {translate("ra.text.addProduct.total")}
          </Typography>

          <Typography className={[classes.totalText, classes.gridRight]}>
            {commaNumber(
              paymentTransaction.summary.total_revenue + deliveryCost
            )}
          </Typography>
        </Box>
      </DialogContent>
      <TextField
        variant="outlined"
        type="datetime-local"
        onChange={(e) => setCustomTime(e.target.value)}
        style={{ height: 60, width: 350, margin: "0 auto" }}
      />
      {/* <TextField
        className={classes.note}
        variant="outlined"
        label={translate("ra.text.note")}
        inputProps={{ maxLength: 400 }}
        value={note}
        onChange={(e) => setNote(e.target.value)}
        helperText={`${note?.length ?? 0}/400`}
      /> */}

      <Button
        className={classes.button}
        autoFocus
        onClick={onClick}
        color="primary"
        variant="contained"
        disabled={disabled}
      >
        {translate("ra.text.addProduct.confirmtoPay")}
      </Button>
    </Dialog>
  );
};

const commaNumber = (num) => {
  try {
    return Number(num).toLocaleString();
  } catch (_) {
    return num;
  }
};

const PurchaseBySection = ({ paymentTransaction }) => {
  const classes = useStyles();
  return (
    <>
      {paymentTransaction.payment.payment_channels?.map(
        (paymentChannel, index) => {
          return (
            <>
              <Typography
                className={[classes.gridLeft, classes.textBottom]}
                noWrap
              >
                {`Purchased by ${paymentChannel.type}`}
              </Typography>
              <Typography className={[classes.gridRight, classes.textBottom]}>
                THB{" "}
                {commaNumber(
                  paymentChannel.amount +
                    (index ===
                    paymentTransaction.payment.payment_channels.length - 1
                      ? paymentTransaction.delivery_cost ?? 0
                      : 0)
                )}
              </Typography>
            </>
          );
        }
      )}
    </>
  );
};
export default FullReceiptDialog;
